import type { PropsWithChildren } from 'react'
import { createContext, useContext } from 'react'

const PdfViewerIframeEmbedContext = createContext<boolean>(false)

export interface IPdfViewerIframeEmbedProviderProps {
  isEnabled: boolean
}

export const PdfViewerIframeEmbedProvider = ({
  isEnabled,
  children,
}: PropsWithChildren<IPdfViewerIframeEmbedProviderProps>) => {
  return (
    <PdfViewerIframeEmbedContext.Provider value={isEnabled}>
      {children}
    </PdfViewerIframeEmbedContext.Provider>
  )
}

export const useIsPdfViewerIframeEmbedEnabled = (): boolean =>
  useContext(PdfViewerIframeEmbedContext)
